// extracted by mini-css-extract-plugin
export default {"contracts":"Contracts_contracts__WGpWa","title":"Contracts_title__ND+wA","list":"Contracts_list__6CMG5","item":"Contracts_item__2HSGm"};